import {useEffect, useState} from "@wordpress/element";
const ACHSurcharge = () => {
    const [text, setText] = useState('');
    const [marginTop, setMarginTop] = useState('0px');

    useEffect(() => {
        if(typeof pgabfwSurcharge !== "undefined" && pgabfwSurcharge.success === '1'){
            let notice = pgabfwSurcharge.check ?? '';
            setText(notice);
            (notice.length > 0)? setMarginTop('15px') : setMarginTop('0px');
        }
    }, []);

    return (
        <div style={{marginTop: marginTop}}><b>{ text }</b></div>
    );
}

window.addEventListener(
    'pgabfw-renderFooterComponentsACH',
    e => e.detail.setComponent(<ACHSurcharge/>)
);